import { saveNotificationPreferencesAction } from "../../../../Actions/UIActions/MyAccount/Settings/SaveNotificationPreferencesAction";
import { sendPasswordResetLinkAction } from "../../../../Actions/UIActions/MyAccount/Settings/SendPasswordResetLinkAction";
import { deleteAccountAction } from "../../../../Actions/UIActions/MyAccount/Settings/DeleteAccountAction";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { myAccountTree } from "../../../../Orchestrator/ConstantTree";


export class SettingsInitStep extends StepFlow {
    get stepName() { return "SettingsInit_Step"; }

    async onEventSetup(): Promise<void> {

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.Settings.SendPasswordResetLink,
                handler: (data: any) => {
                    sendPasswordResetLinkAction.setParams(data.data!);
                    sendPasswordResetLinkAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.Settings.SaveNotificationPreferences,
                handler: (data: any) => {
                    saveNotificationPreferencesAction.setParams(data.data!);
                    saveNotificationPreferencesAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.Settings.DeleteAccount,
                handler: (data: any) => {
                    deleteAccountAction.setParams(data.data!);
                    deleteAccountAction.execute();
                    setTimeout(() => {
                        _eventBus.emit({ eventName: 'USER_LOGOUT', data: null });
                    }, 1000);
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.exitStep,
                handler: () => {
                    this.next();
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("Settings Page Initialize.....")
    }
}

export const SettingsInitStepDeclaration = new StepDefinition({
    stepName: "SettingsInit_Step",
    stepClass: SettingsInitStep
});